import { History } from "history";

import Redirects from "../services/Redirects";

import { redirectRules } from "./redirectRules";

export const watchForRedirects = (history: History) => {
  new Redirects(redirectRules).listen(history);
};
